<template>
  <v-hover>
    <base-card
      slot-scope="{ hover }"
      color="secondary"
      class="elevation-0"
      :class="{'elevation-12 scale-down' : hover}"
      :to="{ path: artwork.isTestable ? (`${artwork.path}/test/default/`) : artwork.path }"
      :width="$vuetify.breakpoint.xsOnly ? '250px': 'auto' "
    >
      <tk-media
        :height="$vuetify.breakpoint.smAndUp ? '300px' : '350px'"
        class="grey lighten-2"
        sizes="600px"
        :media="artwork.media"
        :style="{'background-color': artwork.media.color }"
      >
        <div v-if="!artwork.isForSale" class="sold-ribbon">
          <span>{{ $t('COMMON.SOLD') }}</span>
        </div>
      </tk-media>
      <v-card-title primary-title class="pa-3">
        <v-container px-0 py-0>
          <v-layout row>
            <v-flex pb-0 class="ellipis" shrink text-xs-left>
              <router-link
                class="artwork-title ellipis"
                :to="{ name: 'artist.single', params: { artistSlug: artwork.artist.slug} }"
              >{{ artwork.artist.name }}</router-link>
            </v-flex>
            <v-flex pb-0 grow text-xs-right>
              <div class="title">{{ artwork.price }} €</div>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex pt-1 class="ellipis" text-xs-left>
              <div class="font-weight-light ellipis artwork-title">{{ artwork.title }}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-title>
    </base-card>
  </v-hover>
</template>

<script>
import { Artwork } from "@/services/artwork/Artwork";
export default {
  props: {
    artwork: {
      required: true,
      type: Artwork,
    },
  },
};
</script>

<style lang="scss" scoped>
.horizontal-scroll {
  @media (max-width: 960px) {
    overflow-x: scroll;
  }
}

.artwork-title {
  font-size: 16px;
  text-decoration: none;
}

@media (min-width: 960px) {
  .title {
    font-size: 16px !important;
  }
  .artwork-title {
    font-size: 14px !important;
    &-icon {
      font-size: 12px !important;
      position: relative;
      top: -2px;
    }
  }
  .artwork-dimension {
    font-size: 10px !important;
  }
}
</style>
